//import Libraries
import React from 'react';

//import Components
import Language from '../../../language/language.json';
import LocationCard from './LocationCard/LocationCard';

//import Style classes
import './Locations.css';

const locations = (props) => {
    const locationCards = Language.location.map((obj, idx)=>{
        return <LocationCard data={obj} key={idx} lang={props.lang}/>
    });
    
    return (
        <div className="Locations">
            {locationCards}
        </div>
    )
}

export default locations;


// WEBPACK FOOTER //
// ./src/pages/About/Locations/Locations.js